import{gql as n}from"@apollo/client";const t=n`
  mutation endTrackingAndStartNew(
    $contentPageId: Int!, 
    $userFlowStepTrackId: Int!
    $pageTrackingId: Int!
    $shouldStartNewTracking: Boolean!
    $shouldEndTracking: Boolean!
  ) {
    userFlowStepTrack {
      startContentPageCompletion(pageId: $contentPageId, trackingId: $userFlowStepTrackId)
        @include(if: $shouldStartNewTracking) {
        id
      }

      endContentPageCompletion(trackingId: $pageTrackingId, status: COMPLETED) 
        @include(if: $shouldEndTracking) {
        id
      }
    }
  }
`;export{t as END_TRACKING_AND_START_NEW_MUTATION};
//# sourceMappingURL=useCartoonEndTrackingAndStartNew.graphql.js.map
